import React from 'react';
export function ProblemSection() {
  return <section className="bg-navy-800 py-20 px-4 sm:px-6 lg:px-8" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <div className="border-l-4 border-gold-500 pl-6 sm:pl-10 py-2 space-y-6" data-id="element-118">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-white" data-id="element-119">
            A partir de los 35 años, el hombre promedio pierde hasta un{' '}
            <span className="text-gold-500" data-id="element-120">2% de su testosterona</span> cada
            año.
          </h2>
          <p className="text-xl text-[#e0e0e0] font-medium" data-id="element-121">
            Para cuando llegas a los 45, estás operando con la mitad de tu
            capacidad biológica.
          </p>
          <p className="text-lg text-[#e0e0e0] leading-relaxed" data-id="element-122">
            Esto no solo afecta tu vida íntima. Se manifiesta como esa "neblina
            mental" que te quita agilidad en el trabajo, esa irritabilidad
            inexplicable con quienes más quieres, y un cansancio crónico que
            ningún café logra solucionar. Te han dicho que es "parte de
            envejecer", pero es una mentira que te mantiene rindiendo a medio
            gas.
          </p>
        </div>
      </div>
    </section>;
}